var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _g, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLineEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 201,
    viewBox: "0 0 320 201",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M285.373 30.0747H32.8203V179.659H285.373V30.0747Z",
    fill: "#E6E6E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M285.373 8.15501H32.8203V30.0749H285.373V8.15501Z",
    fill: "#C9C9C9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M263.154 93.3227C228.065 98.3772 241.961 139.818 210.029 137.511C179.406 135.307 192.774 67.5376 159.096 69.6497C132.858 71.2901 130.148 106.046 108.153 107.522C76.526 109.665 78.7184 75.1348 57.2207 75.3603",
    stroke: "#C9C9C9",
    strokeWidth: 4.06,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2207 60.7505V148.984",
    stroke: "#C9C9C9",
    strokeWidth: 1.015,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M108.154 60.7505V148.984",
    stroke: "#C9C9C9",
    strokeWidth: 1.015,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M159.098 60.7505V148.984",
    stroke: "#C9C9C9",
    strokeWidth: 1.015,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M210.029 60.7505V148.984",
    stroke: "#C9C9C9",
    strokeWidth: 1.015,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M260.973 60.7505V148.984",
    stroke: "#C9C9C9",
    strokeWidth: 1.015,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M104.226 47.4426H32.8203V96.3779H104.226V47.4426Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M141.538 134.589H70.1328V179.659H141.538V134.589Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M236.907 120.543H164.436V179.659H236.907V120.543Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M285.373 48.9089H221.357V75.1554H285.373V48.9089Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M100.298 42.9621H22.2246V91.7129H100.298V42.9621Z",
    fill: "#0D9F3F",
    fillOpacity: 0.5
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M29.7246 79.5536V70.7774L42.9704 63.4264L49.3141 71.4951L64.2549 60.7197L70.7915 70.1418L92.8069 55.1218V79.5536H29.7246Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8839 56.4033H29.7246V58.8537H43.8839V56.4033Z",
    fill: "#FFD200"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9434 50.498H29.7246V52.9484H49.9434V50.498Z",
    fill: "#24285B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M135.762 127.792H49.0508V191.183H135.762V127.792Z",
    fill: "#0D9F3F",
    fillOpacity: 0.5
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1977 163.983H61.2715V184.734H73.1977V163.983Z",
    fill: "#FFD200"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M125.44 159.246H113.514V184.724H125.44V159.246Z",
    fill: "#24285B"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7563 147.425H78.8301V184.734H90.7563V147.425Z",
    fill: "#24285B"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M108.489 135.409H96.5625V184.734H108.489V135.409Z",
    fill: "#24285B"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M297.776 111.706H169.297V192.834H297.776V111.706Z",
    fill: "#0D9F3F",
    fillOpacity: 0.5
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M211.521 181.259C205.845 181.265 200.294 179.57 195.572 176.389C190.849 173.208 187.166 168.683 184.99 163.388C182.813 158.092 182.241 152.264 183.345 146.639C184.448 141.015 187.179 135.848 191.19 131.791C195.202 127.735 200.315 124.971 205.882 123.85C211.449 122.729 217.22 123.302 222.465 125.494C227.71 127.687 232.193 131.402 235.347 136.169C238.501 140.936 240.185 146.541 240.185 152.275C240.174 159.953 237.152 167.314 231.78 172.747C226.407 178.179 219.123 181.24 211.521 181.259ZM211.521 131.103C207.376 131.105 203.325 132.349 199.88 134.676C196.434 137.004 193.749 140.311 192.164 144.18C190.58 148.049 190.166 152.305 190.976 156.411C191.786 160.518 193.783 164.289 196.714 167.249C199.646 170.209 203.381 172.224 207.446 173.04C211.512 173.856 215.726 173.436 219.555 171.834C223.384 170.231 226.657 167.517 228.96 164.036C231.262 160.555 232.491 156.462 232.491 152.275C232.486 146.66 230.275 141.276 226.343 137.307C222.411 133.337 217.08 131.106 211.521 131.103Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M211.522 181.259C204.504 181.264 197.728 178.666 192.48 173.959L197.606 168.125C201.441 171.557 206.388 173.45 211.512 173.446L211.522 181.259Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M240.184 152.275H232.46C232.452 146.661 230.24 141.279 226.309 137.31C222.378 133.341 217.048 131.109 211.49 131.103V123.291C219.098 123.299 226.392 126.355 231.771 131.789C237.151 137.223 240.176 144.59 240.184 152.275Z",
    fill: "#24285B"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M211.521 181.259V173.446C217.08 173.441 222.409 171.209 226.34 167.24C230.271 163.271 232.483 157.889 232.491 152.275H240.185C240.177 159.954 237.156 167.317 231.783 172.75C226.41 178.183 219.124 181.243 211.521 181.259Z",
    fill: "#FFD200"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.08
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M212.151 142.894C212.668 142.894 212.821 143.078 212.821 143.591V144.688C213.709 144.784 214.555 145.12 215.269 145.662C215.984 146.203 216.541 146.929 216.881 147.763C217.145 148.307 217.033 148.594 216.434 148.86L215.348 149.353C214.841 149.599 214.597 149.496 214.333 148.953C214.106 148.397 213.708 147.93 213.198 147.62C212.688 147.31 212.094 147.174 211.501 147.23C209.613 147.23 208.751 147.794 208.751 149.066C208.794 149.456 208.971 149.819 209.251 150.092C209.53 150.365 209.895 150.532 210.283 150.562C210.808 150.684 211.34 150.766 211.877 150.808C212.881 150.859 213.872 151.056 214.82 151.393C215.296 151.551 215.739 151.794 216.13 152.111C216.909 152.939 217.332 154.044 217.307 155.186C217.307 157.626 215.693 159.287 212.831 159.708V160.989C212.831 161.502 212.679 161.686 212.161 161.686H210.943C210.435 161.686 210.263 161.502 210.263 160.989V159.851C209.269 159.778 208.319 159.412 207.53 158.798C206.742 158.183 206.149 157.348 205.827 156.396C205.78 156.296 205.757 156.187 205.758 156.077C205.759 155.966 205.785 155.857 205.834 155.759C205.883 155.66 205.953 155.574 206.04 155.506C206.127 155.439 206.228 155.393 206.335 155.371L207.421 154.971C207.979 154.766 208.223 154.899 208.436 155.463C208.661 156.065 209.076 156.576 209.618 156.915C210.159 157.254 210.796 157.403 211.43 157.339C213.46 157.339 214.475 156.693 214.475 155.371C214.493 155.065 214.408 154.763 214.235 154.512C214.062 154.261 213.811 154.076 213.521 153.987C212.815 153.735 212.076 153.59 211.329 153.556C210.311 153.495 209.308 153.277 208.355 152.91C207.89 152.739 207.458 152.49 207.076 152.172C206.676 151.771 206.363 151.291 206.157 150.761C205.95 150.232 205.856 149.665 205.878 149.096C205.878 146.677 207.38 145.067 210.222 144.688V143.56C210.222 143.047 210.395 142.863 210.902 142.863L212.151 142.894Z",
    fill: "black"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M284.237 134.589H249.727V140.31H284.237V134.589Z",
    fill: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M284.196 149.435H249.686V155.156H284.196V149.435Z",
    fill: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M275.538 164.239H249.686V169.96H275.538V164.239Z",
    fill: "black"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M293.767 39.7534H228.178V70.388H293.767V39.7534Z",
    fill: "#0D9F3F",
    fillOpacity: 0.5
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M238.296 53.3788C240.449 53.3788 242.194 51.6162 242.194 49.4418C242.194 47.2675 240.449 45.5049 238.296 45.5049C236.143 45.5049 234.398 47.2675 234.398 49.4418C234.398 51.6162 236.143 53.3788 238.296 53.3788Z",
    fill: "#24285B"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M287.525 47.4426H246.631V51.4514H287.525V47.4426Z",
    fill: "black"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M238.296 64.6364C240.449 64.6364 242.194 62.8737 242.194 60.6994C242.194 58.5251 240.449 56.7624 238.296 56.7624C236.143 56.7624 234.398 58.5251 234.398 60.6994C234.398 62.8737 236.143 64.6364 238.296 64.6364Z",
    fill: "#FFD200"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M287.525 58.6897H246.631V62.6984H287.525V58.6897Z",
    fill: "black"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9181 22.4573C48.8577 22.4573 50.4301 20.8691 50.4301 18.9099C50.4301 16.9507 48.8577 15.3625 46.9181 15.3625C44.9786 15.3625 43.4062 16.9507 43.4062 18.9099C43.4062 20.8691 44.9786 22.4573 46.9181 22.4573Z",
    fill: "#0D9F3F"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1545 22.4573C60.0941 22.4573 61.6664 20.8691 61.6664 18.9099C61.6664 16.9507 60.0941 15.3625 58.1545 15.3625C56.2149 15.3625 54.6426 16.9507 54.6426 18.9099C54.6426 20.8691 56.2149 22.4573 58.1545 22.4573Z",
    fill: "#FFD200"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M69.381 22.4573C71.3206 22.4573 72.8929 20.8691 72.8929 18.9099C72.8929 16.9507 71.3206 15.3625 69.381 15.3625C67.4415 15.3625 65.8691 16.9507 65.8691 18.9099C65.8691 20.8691 67.4415 22.4573 69.381 22.4573Z",
    fill: "#24285B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineEmpty);
export default __webpack_public_path__ + "static/media/line_empty.4a349a4b2b33aaf721fa8e83b4e9ad6b.svg";
export { ForwardRef as ReactComponent };